<template>
    <b-alert v-if="url && !slug" variant="primary" show class="text-left">
        <h5>
            <font-awesome-icon icon="fa-duotone fa-pencil" />
            {{ $t("Claim your username") }}
        </h5>

        <div class="small">
            {{
                $t(
                    "Choose a unique username to brand your invite link. Choose carefully — your username is permanent and can't be changed later."
                )
            }}
        </div>

        <b-input-group class="mt-2">
            <template #prepend>
                <b-input-group-text> @ </b-input-group-text>
            </template>
            <b-form-input
                type="text"
                v-model="username"
                :placeholder="$t('Username')"
                autocomplete="off"
                maxlength="16"
            ></b-form-input>
        </b-input-group>

        <b-alert variant="danger" show v-if="error" class="small">
            {{ error }}
        </b-alert>

        <b-button
            @click="save"
            variant="primary"
            v-if="username"
            pill
            block
            class="mt-2"
        >
            {{ $t("Claim Username") }}
        </b-button>
    </b-alert>
    <div v-else class="rounded p-3 bg-white text-left">
        <div class="d-flex align-items-center justify-content-between">
            <h5 class="mb-0">My Invite Link</h5>
        </div>

        <div class="small text-secondary mt-1">
            {{
                $t(
                    "Both customers and creators can sign up from this link — everyone who joins is tracked to your account"
                )
            }}
        </div>

        <div v-if="url" class="mt-2">
            <b-input-group>
                <b-form-input :value="url" readonly />
                <b-input-group-append>
                    <b-btn v-if="copiedUrl" variant="success">
                        <font-awesome-icon icon="fa-light fa-check" />
                        Copied
                    </b-btn>
                    <b-btn v-else @click="copyUrl" variant="primary">
                        {{ $t("Copy") }}
                    </b-btn>
                </b-input-group-append>
            </b-input-group>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

import copy from "clipboard-copy";

export default {
    data() {
        return {
            username: null,
            error: null,
        };
    },
    computed: {
        ...mapState("affiliate", ["url", "copiedUrl", "slug"]),
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    methods: {
        copyUrl() {
            copy(this.url);

            this.$store.commit("affiliate/setCopiedUrl", true);

            setTimeout(() => {
                this.$store.commit("affiliate/setCopiedUrl", false);
            }, 3000);
        },
        save() {
            this.api
                .post("/invite/slug", {
                    username: this.username,
                })
                .then(() => {
                    this.$store.dispatch("affiliate/refresh");
                })
                .catch((error) => {
                    if (error?.response?.data?.errors?.username?.length) {
                        this.error =
                            error.response.data.errors.username.join(",");
                    }
                });
        },
    },
    components: {},
};
</script>